<template>
  <div
    :id="id"
    :ref="id"
    :class="collapseClass"
  >
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: 'BCollapseKariermu',
  props: {
    id: {
      type: String,
      required: true
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  emits: ['input'],
  data () {
    return {
      observer: null
    }
  },
  computed: {
    collapseClass () {
      return this.visible ? 'b-collapse-kariermu collapse show' : 'b-collapse-kariermu collapse'
    }
  },
  methods: {
    onClassChange (mutationsList) {
      mutationsList.forEach(mutation => {
        if (mutation.type === 'attributes' &&
          mutation.attributeName === 'class' &&
          mutation.target.className.includes('show')
        ) {
          this.$emit('input', true)
          this.observer.disconnect()
        }
      })
    }
  },
  mounted () {
    if (this.visible) {
      this.$emit('input', true)
    } else {
      this.observer = new MutationObserver(this.onClassChange)
      this.observer.observe(this.$refs[this.id], {
        attributes: true,
        attributeFilter: ['class']
      })
    }
  },
  beforeUnmount () {
    if (this.observer) {
      this.observer.disconnect()
    }
  }
}
</script>
<style scoped>
.b-collapse-kariermu {
  transition: height 0.35s ease;
}
</style>
